import { ScreenBase } from "@frui.ts/screens";

export default class ProductsViewModel extends ScreenBase {
  constructor() {
    super();
    this.navigationName = "produkty-vcel";
    this.name = "Produkty včel";
  }
}
